<script setup>
import { cloneDeep } from 'lodash';
import {
  watch, ref, nextTick, reactive,
} from 'vue';
import { modelErrorsToHtmlText } from '../../../../libs/cifra/model_errors';

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  error: { type: [String, Array], default: null },
});

const emits = defineEmits(['update:modelValue']);

const referencias = reactive([...cloneDeep(props.modelValue)]);
const lineaReferencia = ref(null);

function eliminarReferencia(index) {
  if (index < 0) { return; }

  const referencia = referencias[index];
  if (referencia !== null) {
    referencias.splice(index, 1);
  }
}

function addReferencia() {
  referencias.push('');
  nextTick(() => {
    lineaReferencia.value[referencias.length - 1].focus();
  });
}

watch(referencias, () => {
  emits('update:modelValue', referencias);
});
</script>

<template>
  <table class="table m-b-none">
    <thead>
      <tr>
        <th>
          {{ $I18n.t(
            'activerecord.attributes.lomloe/situacion_aprendizaje_actividad.referencias'
          ) }}
        </th>
        <th class="col-min">
          <button
            type="button"
            class="btn btn-cifra btn-xs"
            @click="addReferencia"
          >
            <i class="fa fa-plus"></i>
          </button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(_referencia, index) in referencias" :key="index">
        <td>
          <input ref="lineaReferencia" v-model="referencias[index]" class="form-control">
        </td>
        <td>
          <i
            class="fa fa-trash text-danger clickable"
            @click="eliminarReferencia(index)"
          ></i>
        </td>
      </tr>
    </tbody>
  </table>
  <p v-if="props.error" class="text-danger">
    {{ modelErrorsToHtmlText(error) }}
  </p>
</template>

<style scoped>
  table > tbody > tr > td:last-child {
    text-align: center;
  }
  table > tbody > tr > td {
    vertical-align: middle;
  }
  abbr {
    border: 0;
    text-decoration: none;
    color: #fe1d12;
  }
</style>
